import numericCharactersRegex from './regex';

export default class Validation {
  constructor(context) {
    this.context = context;

    // Bind scope to methods
    this.validateCheckbox = this.validateCheckbox.bind(this);
    this.validateValue = this.validateValue.bind(this);

    // Initialise properties
    this.properties = {};
    this.stateHolder = null;
    this.valid = true;

    // Initialise component
    this.init();
  }

  init() {
    // Store properties to validate
    if (this.context.hasAttribute('required')) this.properties.required = true;

    const maxlength = this.context.getAttribute('maxlength');
    if (maxlength) this.properties.maxlength = parseInt(maxlength, 10);

    const minlength = this.context.getAttribute('minlength');
    if (minlength) this.properties.minlength = parseInt(minlength, 10);

    const regex = this.context.getAttribute('data-form-regex');
    if (regex) this.properties.regex = new RegExp(regex);
  }

  initTextField() {
    // Store element to hold state
    this.stateHolder = this.context;

    // Initialise validation
    if (this.context.value !== '') this.validateValue();
    this.context.addEventListener('keyup', this.validateValue);
  }

  initSelectField() {
    // Store element to hold state
    this.stateHolder = this.context.parentElement;

    // Initialise validation
    if (this.context.value !== '') this.validateValue();
    this.context.addEventListener('change', this.validateValue);
  }

  initCheckboxField() {
    // Initialise validation
    if (this.context.checked) this.validateCheckbox();
    this.context.addEventListener('change', this.validateCheckbox);
  }

  validateValue() {
    // Get field value
    const { value } = this.context;

    // Validate required field
    const invalidRequired = this.properties.required && value === '';

    // Validate properties
    if (
      invalidRequired ||
      (this.properties.maxlength && !this.maxlengthValid(value)) ||
      (this.properties.minlength && !this.minlengthValid(value)) ||
      (this.properties.regex && !this.regexValid(value))
    ) {
      this.valid = false;
    } else {
      this.valid = true;
    }

    // Set class state on field
    this.stateHolder.classList.toggle('valid', this.valid);
    this.stateHolder.classList.toggle('invalid', !this.valid);
    this.stateHolder.classList.toggle('required', invalidRequired);
  }

  validateCheckbox() {
    // Check validation is required
    if (!this.properties.required) return;

    // Get all checkboxes in group
    const name = this.context.getAttribute('name');
    const checkboxGroup = document.querySelectorAll(`input[name="${name}"]`);

    // Loop checkbox group & validate
    this.valid = false;

    checkboxGroup.forEach((checkbox) => {
      if (checkbox.checked) {
        this.valid = true;
      }
    });

    checkboxGroup.forEach((checkbox) => {
      checkbox.classList.toggle('valid', this.valid);
      checkbox.classList.toggle('invalid', !this.valid);
      checkbox.classList.toggle('required', !this.valid);
      checkbox.closest('.Form_field').classList.toggle('error', !this.valid);
    });
  }

  maxlengthValid(value) {
    return value.length <= this.properties.maxlength;
  }

  minlengthValid(value) {
    return value.length >= this.properties.minlength;
  }

  regexValid(value) {
    return this.properties.regex.test(value);
  }
}

/**
 * Blocks invalid non-numeric characters and multiple decimal points in input fields.
 * Put on input in 'keydown' event, not in handler as this is the only way it wil work with Safari!
 * @param {KeyboardEvent} event - The keyboard event triggered when typing in an input field.
 */
export const blockInvalidCharactersForNumberInput = (event) => {
  const { key, target } = event;

  // Check if key is a decimal point and if one already exists in the input
  const isDecimalPoint = key === '.';
  const alreadyHasDecimal = target.value.includes('.');

  if (
    (isDecimalPoint && alreadyHasDecimal) || // Block decimal if already present
    // Prevent any non-numeric characters except for decimal
    (!isDecimalPoint && !numericCharactersRegex.test(key) && key.length === 1)
  ) {
    event.preventDefault();
  }
};
